import React from "react";

const AccountingOverview = ({ ledgers = [], accountGroups = [] }) => {
    const activeLedgers = ledgers.filter( (ledger) => ledger.is_active !== false );

    const systemLedgers = ledgers.filter( (ledger) => ledger.is_system );

    const customerLedgers = ledgers.filter(
        (ledger) => ledger.ledger_type === "customer"
    );

    const debitLedgers = ledgers.filter(
        (ledger) => ledger.balance_nature?.toLowerCase() === "debit"
    );

    const creditLedgers = ledgers.filter(
        (ledger) => ledger.balance_nature?.toLowerCase() === "credit"
    );

    const openingBalance = ledgers.reduce(
        (total, ledger) => total + Number(ledger.opening_balance || 0),
        0
    );

    const activeGroups = accountGroups.filter(
        (group) => group.is_active !== false
    );

    const systemGroups = accountGroups.filter( (group) => group.is_system );

    return (
        <div className="accounting-overview">

            <div className="accounting-stat">
                <span className="accounting-stat-label">
                    Ledgers
                </span>

                <strong>
                    {ledgers.length}
                </strong>

                <small>
                    {activeLedgers.length} active
                </small>
            </div>

            <div className="accounting-stat">
                <span className="accounting-stat-label">
                    Account Groups
                </span>

                <strong>
                    {accountGroups.length}
                </strong>

                <small>
                    {activeGroups.length} active
                </small>
            </div>

            <div className="accounting-stat">
                <span className="accounting-stat-label">
                    Customer Accounts
                </span>

                <strong>
                    {customerLedgers.length}
                </strong>

                <small>
                    Customer ledgers
                </small>
            </div>

            <div className="accounting-stat">
                <span className="accounting-stat-label">
                    Opening Balance
                </span>

                <strong>
                    ₹{openingBalance.toLocaleString("en-IN")}
                </strong>

                <small>
                    Across all ledgers
                </small>
            </div>

            <div className="accounting-stat accounting-stat-secondary">
                <span className="accounting-stat-label">
                    Structure
                </span>

                <strong>
                    {systemGroups.length} / {systemLedgers.length}
                </strong>

                <small>
                    System groups / ledgers
                </small>
            </div>

            <div className="accounting-stat accounting-stat-secondary">
                <span className="accounting-stat-label">
                    Balance Nature
                </span>

                <strong>
                    {debitLedgers.length}D · {creditLedgers.length}C
                </strong>

                <small>
                    Ledger classification
                </small>
            </div>
        </div>
    );
};

export default AccountingOverview;
